import {
    IWorkflowNode,
    resourceNameWorkflowNode,
} from "motw_core/Entity/IWorkflowNode";
import { GetAllVisibleNodesAsync } from "motw_core/Workflows/GetVisibleNodes";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import ClientDataProvider from "../../External/ClientDataProvider/ClientDataProvider";
import { AreYouSure } from "../../Shared/RenderSwal/RenderSwal";
import { GotoParentAsync } from "../GotoNode";
import { TouchWorkflowNodeParentsAsync } from "./TouchWorkflowNodeParentsAsync";

export async function DeleteNodeAsync(node: IWorkflowNode) {
    if (!(await DoesNodeHaveChildrenAsync(node))) {
        await LocalDeleteAsync(node);
    }

    await DeleteNodeFromDbAsync(node);
}

export async function DeleteMultipleNodesAsync(nodesToDelete: IWorkflowNode[]) {
    const nodeIds = Array.from(new Set(nodesToDelete.map((node) => node.id)));
    const delimitedIds = nodeIds.join(",");

    await WithAnimatedProgressBarAsync(() =>
        ClientDataProvider.DeleteRecordsAsync(
            `${resourceNameWorkflowNode}?id=in.(${delimitedIds})`
        )
    );

    await TouchDeletedNodeParentsAsync(nodesToDelete);

    const workflows = GetWorkflowsState();

    if (workflows) {
        workflows.setState({
            visibleNodes: workflows.state.visibleNodes.filter(
                (node) => !nodeIds.includes(node.id)
            ),
            selectedNodeIds: workflows.state.selectedNodeIds.filter(
                (nodeId) => !nodeIds.includes(nodeId)
            ),
        });
    }

    await GotoParentAsync(nodesToDelete[0]);
}

async function DoesNodeHaveChildrenAsync(node: IWorkflowNode) {
    const nodesToDelete = await GetAllVisibleNodesAsync(node);

    if (!nodesToDelete) {
        return;
    }

    const result = nodesToDelete.length > 1;
    return result;
}

async function DeleteNodeFromDbAsync(node: IWorkflowNode) {
    const nodesToDelete = await GetAllVisibleNodesAsync(node);

    if (!(await DoesNodeHaveChildrenAsync(node))) {
        if (!nodesToDelete) {
            return;
        }
        const nodeToDelete = nodesToDelete[0];

        await WithAnimatedProgressBarAsync(() =>
            ClientDataProvider.DeleteRecordsAsync(
                `${resourceNameWorkflowNode}?id=eq.${nodeToDelete.id}`
            )
        );

        await TouchDeletedNodeParentsAsync([nodeToDelete]);

        await GotoParentAsync(nodeToDelete);
        return;
    }

    const DeleteNodesCallAsync = async () => {
        if (!nodesToDelete) {
            return;
        }

        await DeleteMultipleNodesAsync(nodesToDelete);
    };

    AreYouSure(
        `Are you sure? ${nodesToDelete!.length} nodes will be deleted`,
        DeleteNodesCallAsync
    );
}

async function TouchDeletedNodeParentsAsync(nodesToDelete: IWorkflowNode[]) {
    const deletedNodeIds = new Set(nodesToDelete.map((node) => node.id));
    const parentIds = Array.from(
        new Set(
            nodesToDelete
                .map((node) => node.parentid)
                .filter((parentId) => !deletedNodeIds.has(parentId))
        )
    );

    await TouchWorkflowNodeParentsAsync(parentIds);
}

async function LocalDeleteAsync(node: IWorkflowNode) {
    const workflows = GetWorkflowsState();

    const visibleNodes = workflows.state.visibleNodes.filter(
        (n) => n.id !== node.id
    );

    workflows.setState({ visibleNodes });
    await GotoParentAsync(node);
}
